import React from "react";

const CPP_Syntax = () => {
  return (
    <div>
      <h1>CPP_Syntax Component</h1>
      <p>Content for CPP_Syntax goes here...</p>
    </div>
  );
};

export default CPP_Syntax;
